import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService {
  apiUrl = environment.appRoot + '/api/';

  constructor(private http: HttpClient) {}

  getSignedUrl(endpoint: string, params: any): Observable<{ apiKey: string }> {
    return this.http.get<{ apiKey: string }>(`${environment.appRoot}${endpoint}`);
  }
}
